"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyBonuses = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var EmptyBonuses = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var onClick = function () { return router.push(generateUrlWithLang("/promotions")); };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("h3", { className: styles_module_scss_1.default.title }, t('noActiveBonusTitle')),
        react_1.default.createElement("p", { className: styles_module_scss_1.default.subtitle }, t('noActiveBonusText')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.button },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "40px", onClick: onClick, maxWidth: "100%" },
                react_1.default.createElement("span", { className: styles_module_scss_1.default.button },
                    t('all'),
                    "\u00A0",
                    t('promotions'))))));
};
exports.EmptyBonuses = EmptyBonuses;
exports.default = exports.EmptyBonuses;
